<template>
  <tr :class="rowClass">
    <td
      class="cursor-pointer"
      @click="$emit('block-select', contentBlock.systemName)"
    >
      <div class="title-container">
        <div class="bold">{{ contentBlock.title }}</div>
      </div>
      <p class="only-mobile text-xs text-gray-600">
        {{ truncate(contentBlock.description, 100) }}
      </p>
      <p
        v-if="isHtmlBlock"
        class="only-mobile text-xs text-gray-600 version-info"
      >
        Version: {{ toUiVersion(contentBlock.versionNumber) }}
      </p>
      <p
        v-if="isHtmlBlock"
        class="only-mobile text-xs text-gray-600 version-info"
      >
        Last Published: {{ $filters.short(contentBlock.versionDate) }}
      </p>
    </td>
    <td class="hide-mobile">{{ contentBlock.description }}</td>
    <td class="hide-mobile">
      <tag v-for="tag in contentBlock.tags" :key="tag" :tag="tag"></tag>
    </td>
    <td class="hide-mobile">{{ toUiVersion(contentBlock.versionNumber) }}</td>
    <td class="hide-mobile">{{ $filters.short(contentBlock.versionDate) }}</td>
    <td class="action-buttons">
      <icon v-if="blockUsed" name="fa-check" class="block-used-icon" />
      <action-button
        v-if="newVersionAvailable"
        icon="fa-file-import"
        tooltip="New version available"
        @click="$emit('block-refresh', contentBlock.systemName)"
      />
      <action-button
        v-if="canUpdate"
        color="danger"
        icon="fa-file-export"
        tooltip="Update sharedo from the document."
        @click="$emit('update-content', contentBlock.systemName)"
      />
    </td>
  </tr>
</template>
<script>
import documentModel from "@/mixins/documentModel";
import tableRow from "@/mixins/tableRow";
import profile from "@/mixins/profile";
import { truncate } from "@/util/stringUtil";
import Tag from "@/components/common/tags/Tag.vue";
import { toUiVersion } from "@/util/versionUtil";
import {
  HTML_CONTENT_BLOCK,
  CONTENT_BLOCK,
} from "@/constants/contentControlTypes";
import {
  ADMIN_DOCUMENT_ASSEMBLY,
  CONTENT_BLOCKS_CREATE,
} from "@/constants/permissions";

export default {
  components: { Tag },
  mixins: [tableRow, documentModel, profile],
  props: ["contentBlock"],
  computed: {
    contentControls: function () {
      if (this.documentModel) {
        const contentControls =
          this.documentModel.findContentControlBySystemName(
            this.contentBlock.systemName
          );

        return contentControls;
      }

      return [];
    },
    blockUsed: function () {
      if (this.contentControls.length > 0) {
        return this.contentControls.some(
          (c) => c.type == HTML_CONTENT_BLOCK || c.type == CONTENT_BLOCK
        );
      }

      return false;
    },
    newVersionAvailable: function () {
      if (this.contentControls.length > 0) {
        return this.contentControls.some(
          (c) =>
            c.type == HTML_CONTENT_BLOCK &&
            c.version.number < this.contentBlock.versionNumber
        );
      }

      return false;
    },
    canUpdate: function () {
      if (
        (this.hasPermission(ADMIN_DOCUMENT_ASSEMBLY) ||
          this.hasPermission(CONTENT_BLOCKS_CREATE)) &&
        this.contentControls.length > 0
      ) {
        var intances = this.contentControls.filter(
          (c) => c.type == HTML_CONTENT_BLOCK
        );

        if (intances.length === 1) {
          return intances[0].version.number === this.contentBlock.versionNumber;
        }
      }

      return false;
    },
    isHtmlBlock: function () {
      return this.contentBlock.templateType === "content-block-html";
    },
  },
  emits: ["block-select", "block-refresh", "update-content"],
  methods: {
    truncate,
    toUiVersion,
  },
};
</script>
<style lang="scss" scoped>
@import "../../_css/variables";

.title-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.block-used-icon {
  color: $primary;
}

.action-buttons {
  white-space: nowrap;
  vertical-align: top;
}

.version-info {
  margin-top: 0;
  margin-bottom: 0;
}
</style>
